/**
 * React Query hook for the open questions Wingo asks (XC-PRICE-GUARD U3b §5): the Inbox's
 * "Questions from Wingo" section and the sidebar's Inbox count read the same key, so the two can
 * never disagree. Read-only: the answer is the Business Profile's door (U6b).
 */

import { useQuery } from '@tanstack/react-query';

import { fetchOpenQuestions } from '@/services/openQuestionsService';
import type { OpenQuestions } from '@/types/businessProfile/openQuestions';

export const openQuestionKeys = {
  all: ['open-questions'] as const,
};

export function useOpenQuestions() {
  return useQuery<OpenQuestions>({
    queryKey: openQuestionKeys.all,
    queryFn: fetchOpenQuestions,
    staleTime: 60_000,
  });
}
